export function ImmediateFont() {
  const style = document.createElement('style');
  style.innerText = `
  @font-face {
    font-family: 'AlibabaPuHuiTi';
    src: url(${require('./fonts/AlibabaPuHuiTi-3-55-Regular.ttf')}) format('truetype');
    font-display: swap;
  }
  `;
  document.head.appendChild(style);
}

export function delayLoadFont() {
  // const style = document.createElement('style');
  // style.innerText = `
  // @font-face {
  //   font-family: 'AlibabaPuHuiTi';
  //   src: url(${require('./fonts/AlibabaPuHuiTi-3-55-Regular.ttf')}) format('truetype');
  //   font-display: swap;
  // }
  // `;
  // document.head.appendChild(style);
}
